import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PasswordForgotten from '../components/login/PasswordForgotten';
import '../css/style.css';
import '../components/Home.css';
import {  Row, Col } from 'react-bootstrap';


class PasswordForgottenLayout extends Component {

    render(){
        return (
            <SimpleLayout>
            <Row   className=" justify-content-lg-center mt-5">
              <Col lg={6}>
                <PasswordForgotten  />
                </Col>
        </Row>
        
      </SimpleLayout>        
        );
    }

}

export default PasswordForgottenLayout;